import {Badge} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faFolderOpen} from "@fortawesome/free-regular-svg-icons";
import {v4 as uuidv4} from "uuid";
import {useState} from "react";

export default function FolderGrid({folders, onSelect}){

    const [active, setActive] = useState(-1);

    const handleClick = (pos)=>{
        if(active !== pos)
            return setActive(pos)

        setActive(-1)
        onSelect(folders[pos])
    }

    const files = folders ? folders : [];


    return (
        <div className={"protocols_grid"}>
            {
                files.map((f,i)=><Folder key={uuidv4()} folder={f} active={i === active} onClick={()=>{handleClick(i)}}  />)
            }
        </div>
    )
    
}

function Folder(props){


    const isActiveClass = props.active ? 'isActive':'';

    const fileName = props.folder.name === null ? 'Inne' : props.folder.name;


    return (
        <div onClick={props.onClick} className={`file_element ${isActiveClass} text-center position-relative`} >
            <Badge pill bg="secondary position-absolute" style={{right:"4px", top:"4px"}}>{props.folder.files}</Badge>
            <div><FontAwesomeIcon className={"fs-1"} icon={faFolderOpen} /></div>
            {fileName}
        </div>
    )

}